// extracted by mini-css-extract-plugin
export default {"Input":"index_Input_0-ve8","error":"index_error_-zME5"};